import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination
} from '@mui/material';

const TableData = ({
  data,
  headers,
  rowsPerPageOptions,
  // server-side pagination props (optional)
  page: externalPage,
  pageSize: externalPageSize,
  totalRecords,
  onPageChange,
  onPageSizeChange,
}) => {
  const isServerSide = typeof onPageChange === 'function';

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);

  const handleChangePage = (_, newPage) => {
    if (isServerSide) {
      onPageChange(newPage + 1); // convert to 1-based for API
    } else {
      setPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    if (isServerSide) {
      onPageChange(1); // reset to first page
      if (onPageSizeChange) onPageSizeChange(newSize);
    } else {
      setRowsPerPage(newSize);
      setPage(0);
    }
  };

  useEffect(() => {
    if (!isServerSide && page > 0 && page * rowsPerPage >= data.length) {
      setPage(0);
    }
  }, [data.length]);

  const displayData = isServerSide
    ? data
    : data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const currentPage = isServerSide ? (externalPage || 1) - 1 : page;
  const currentRowsPerPage = isServerSide ? (externalPageSize || rowsPerPageOptions[0]) : rowsPerPage;
  const count = isServerSide ? (totalRecords || 0) : data.length;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell key={header}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {displayData.map((item, index) => (
            <TableRow key={index}>
              {headers.map((header) => (
                <TableCell key={header}>{item[header]}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={count}
        rowsPerPage={currentRowsPerPage}
        page={currentPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
};

export default TableData;
